import { render, staticRenderFns } from "./BssLog2.vue?vue&type=template&id=48268b5f&scoped=true"
import script from "./BssLog2.vue?vue&type=script&lang=js"
export * from "./BssLog2.vue?vue&type=script&lang=js"
import style0 from "./BssLog2.vue?vue&type=style&index=0&id=48268b5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48268b5f",
  null
  
)

export default component.exports